import { useContext } from 'react';

import { UPDATE_CHART_SETTINGS } from '../actions/actions';
import { store } from '../context/store';

export default function useChartSettings() {
  const { state, dispatch } = useContext(store);
  const { chart } = state.settings;

  const setChartSettings = (updatedSettings) => {
    dispatch({ payload: updatedSettings, type: UPDATE_CHART_SETTINGS });
  };

  return [chart, setChartSettings];
}
